import app from '../app.first';

app.SelectAll = class extends app.Component {
	onReady() {
		let selectAllEl = document.getElementById("selectAll");
		selectAllEl.addEventListener("click", async function () {
			let candidateIdElements = document.querySelectorAll(".candidate-data");
			let candidateIds = [];
			// put the result of /recruiter/search/get-selected-candidates.json, to candidateIds
			// if selectAllEl is checked, then add the candidateId to candidateIds

			let candidates = await app.ajax(
				`/recruiter/search/get-selected-candidates.json`,
				{},
				false
			);

			for (let candidate of candidates.candidates) {
				candidateIds.push(candidate.id);
			}

			if (selectAllEl.checked) {
				for (let candidateIdElement of candidateIdElements) {
					candidateIdElement.classList.add("is-selected");
					let selectedCandidateId = candidateIdElement.getAttribute("data-candidate-id");
					candidateIds.push(selectedCandidateId);
				}
				await app.ajax(
					`/recruiter/search/select-candidates.json`,
					{ candidateIds: candidateIds },
					false
				);
			}
			else {
				for (let candidateIdElement of candidateIdElements) {
					candidateIdElement.classList.remove("is-selected");
					let selectedCandidateId = candidateIdElement.getAttribute("data-candidate-id");
					candidateIds.push(selectedCandidateId);
				}
				await app.ajax(
					`/recruiter/search/remove-candidates.json`,
					{ candidateIds: candidateIds },
					false
				);
			}
			$(document).trigger('Recruiter.Search.selectedCandidates.change');
		});

		let rowPerPageOptions = document.getElementById("row-per-page-options");
		rowPerPageOptions.addEventListener("change", function () {
			let rowPerPageInput = document.getElementById("row-per-page");
			rowPerPageInput.value = rowPerPageOptions.value;
			$(".apply-filter").click();
		});
	}
}
